module.exports = __webpack_public_path__ + "img/hc_pro_three_1.312fea40.jpg";